
<div *ngIf="!onlyInput else inputTemplate" [ngClass]="{'contain-bo' : mobile}" class="container-fluid h-100" #content>
  <div #header class="row">
    <img [style.height.px]="mobile ? 35 : 80" class="col-auto" [src]="'upload.png' | getimage :'QLIB'" />
    <div class="col">
      <div [style.fontSize.rem]="mobile ? 1 : 2" class="q-c-main q-bold">{{'ext_uploadTitle' | trad}}</div>
      <p [style.fontSize.rem]="mobile ? 0.8 : 1" class="q-text-s q-bold">{{'ext_uploadSize' | trad}} : {{maxUploadSize}} Mo</p>
    </div>
  </div>
  
  <div class="row" [style.height]="sanitizer.bypassSecurityTrustStyle('calc(100% - ' + header.offsetHeight + 'px)')" >
  <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
  </div>
</div>


<ng-template #inputTemplate>
  <ng-container *ngIf="!docIsReadOnly else ReadOnlyTemplate">
    <div *ngIf="boHidden" class="col-12">
      <button class="q-btn q-success" (click)="getEvent(model)"><i class="fas fa-save"></i></button>
    </div>
    <div *ngIf="fileIsPDF" class="q-check col-12">
      <input type="checkbox" id="eraseDocxFileIfNewDocIsPDFCheckbox" [ngModel]="eraseDocxFileIfNewDocIsPDF" (ngModelChange)="OnEraseDocxFileIfNewDocIsPDFChange($event)" />
      <label for="eraseDocxFileIfNewDocIsPDFCheckbox">
        <span></span>écraser l'éventuel .docx existant
      </label>
    </div>
    <div class="col-12 px-0 my-3">
      <div *ngIf="!mobile" class="upload-file-drop col-10 d-flex flex-column">
        <p class="q-text-m q-bold">{{'ext_depositFileLabel' | trad}} :</p>
        <label for="file" class="dropzone h-100 position-relative d-flex flex-column justify-content-center text-center">
          <span class="h-100">
            <input type="file" id="file" class="file h-100 w-100 position-absolute" (change)="onSelectChange($event)"
                   accept=".xls, .xlsx, .docx, .doc, .txt, .pdf, .ppt, .pptx, .jpeg, .gif, .jpg, .png, .zip, .rar" />
          </span>
        </label>
        <input type="text" class="form-control q-input-no-border q-input-disabled" disabled [ngModel]="path"
               placeholder="{{'ext_placeholderFile' | trad}}" aria-label="Small" aria-describedby="inputGroup-sizing-sm">
      </div>
      <ng-container *ngIf="mobile">
        <p class="pl-4 col-12 q-text-m q-bold">{{'ext_parcourirLabel' | trad}} :</p>
        <div class="col-12">
          <div class="input-group input-group col-auto">
            <input type="text" class="form-control q-input-no-border q-input-disabled" disabled [ngModel]="path"
                   placeholder="{{'ext_placeholderFile' | trad}}" aria-label="Small" aria-describedby="inputGroup-sizing-sm">
            <div class="input-group-append">
              <label id="inputGroup-sizing-sm" for="filemanuel" class="filemanuel input-group-text q-b-selected">
                <i class="far fa-file"></i>{{'ext_parcourir' | trad}}
              </label>
              <input type="file" id="filemanuel" class="d-none" (change)="onSelectChange($event)" />
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-template #ReadOnlyTemplate>
    <p class="col-12 text-center m-2 q-text-m q-bold">Le document ne peut être modifié car en lecture seule.</p>
  </ng-template>
</ng-template>
